import EA from 'helpers/init';

export default EA.Methods.galleryModal = ($this) => {
    const galleryModal = $this.querySelector('.gallery-listing-modal');
    const modalImgs = $this.querySelectorAll('.gallery-img');
    const galleryItems = $this.querySelectorAll('.gallery-listing-item');
    const slider = $this.querySelector('.swiper');
    const current = $this.querySelector('.gallery-current-slide');
    const slideLength = $this.querySelector('.gallery-slide-length');
    const next = $this.querySelector('.swiper-btn-next');
    const prev = $this.querySelector('.swiper-btn-prev');
    const galleryOverlay = $this.querySelector('.gallery-overlay');
    const closeButton = $this.querySelector('.swiper-btn-close');
    let modalSrc = $this.querySelector('.gallery-modal-img');
    let imgIndex = 0;
    let ts;
    
    function imgSlides() {
        if (galleryItems.length > 9) {
            slideLength.innerHTML = galleryItems.length;
        } else {
            slideLength.innerHTML = `0${galleryItems.length}`;
        }
    }

    function startTouch(e) {
        ts = e.touches[0].clientX;
    }

    function endTouch(e) {
        let te = e.changedTouches[0].clientX;
        if(ts > te + 5) {
            nextImg();
        } else if(ts < te - 5) {
            prevImg();
        }
    }

    function close() {
        galleryModal.classList.remove('active');
        document.body.classList.remove('modal-active');
        next.classList.remove('disabled');
        galleryItems.forEach(function (item) {
            item.classList.remove('active');
        });
    };

    function nextImg() {
        const activeListItem = document.querySelector('.gallery-listing-item.active');
        const activeListNextSrc = activeListItem.nextElementSibling.querySelector('.gallery-img').getAttribute('src');
        
        if (activeListItem.nextElementSibling) {
            if ((imgIndex + 1) === galleryItems.length) {
                next.classList.add('disabled');
                prev.classList.remove('disabled');
            } else {
                next.classList.remove('disabled');
                prev.classList.remove('disabled');
            }

            galleryItems.forEach(function (item) {
                item.classList.remove('active');
            });
            
            activeListItem.nextElementSibling.classList.add('active');
            modalSrc.setAttribute('src', activeListNextSrc);
            imgIndex ++;
            
            if (imgIndex >= 10) {
                current.innerHTML = imgIndex;
            } else {
                current.innerHTML = `0${imgIndex}`;
            }
        };
    };

    function prevImg() {
        const activeListItem = document.querySelector('.gallery-listing-item.active');
        const activeListPrevSrc = activeListItem.previousElementSibling.querySelector('.gallery-img').getAttribute('src');
        
        if (activeListItem.previousElementSibling) {
            if ((imgIndex - 1) < galleryItems.length) {
                next.classList.remove('disabled');
                if ((imgIndex - 1) === 1) {
                    prev.classList.add('disabled');
                }
            } 

            galleryItems.forEach(function (item) {
                item.classList.remove('active');
            });

            activeListItem.previousElementSibling.classList.add('active');
            modalSrc.setAttribute('src', activeListPrevSrc);
            imgIndex --;


            if (imgIndex >= 10) {
                current.innerHTML = imgIndex;
            } else {
                current.innerHTML = `0${imgIndex}`;
            }

        };
    };
    
    // IMG ADDING SRC TO MODAL
    modalImgs.forEach(function (img, index) {
        img.addEventListener('click', function () {
            const activeImg = img.getAttribute('src');
            galleryModal.classList.add('active');
            document.body.classList.add('modal-active');
            modalSrc.setAttribute('src', activeImg);

            galleryItems.forEach(function (item) {
                item.classList.remove('active');
            });

            img.closest('.gallery-listing-item').classList.add('active');

            if ((index + 1) === galleryItems.length) {
                next.classList.add('disabled');
                prev.classList.remove('disabled');
            } else if (index >= 1) {
                prev.classList.remove('disabled');
            }
            if (index >= 9) {
                imgIndex = index + 1;
                current.innerHTML = imgIndex; 
            } else {
                imgIndex = index + 1;
                current.innerHTML = `0${imgIndex}`; 
            }

            imgSlides();
        });
    });

    // CLOSING MODAL
    galleryOverlay.addEventListener('click', function () {
        close();
    });
    closeButton.addEventListener('click', function () {
        close();
    });

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === 'Escape' && document.body.classList.contains('modal-active')) {
            close();
        }
    });
    
    // TOUCH MOBILE EVENTS
    slider.addEventListener('touchstart', startTouch);
    slider.addEventListener('touchend', endTouch);

    // MODAL OPEN NEXT AND PREV EVENTS
    next.addEventListener('click', function () {
        nextImg();
    });

    prev.addEventListener('click', function () {
        prevImg();
    });


}



